import React, { useState } from "react";
import {
  AppBar,
  Dialog,
  IconButton,
  Toolbar,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const TemplateCreationModal = ({ open, onClose, onCreate }) => {
  const [templateName, setTemplateName] = useState("");

  const handleCreateTemplate = () => {
    onCreate(templateName);
    setTemplateName(""); // Reset template name
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Create Workout Template
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2 }}>
        <TextField
          label="Template Name"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />
        <Button onClick={handleCreateTemplate}>Save Template</Button>
        <Button onClick={onClose}>Cancel</Button>
      </Box>
    </Dialog>
  );
};

export default TemplateCreationModal;
